import commoncss from "./../../css/common.module.css";
import bookclosuretaskscss from "./../../css/bookclosuretasks.module.css";
import Modal from "./../../elements/Modal";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import ChooseFromLib from "./../../assets/imgs/choose_from_lib.png";
import AddNewTask from "./../../assets/imgs/add_new_task.png";

const AddTaskModal = ({ handleClose, setAddTaskModal, setAddNewTaskModal }) => {
  const redirectTo = (link) => {
    window.location.href = link;
  };

  return (
    <Modal
      title="Add Task"
      bodycss={commoncss.unsetPadding}
      width="fit-content"
      headerActions={
        <CloseIcon
          onClick={() => {
            handleClose();
            setAddTaskModal(false);
          }}
          className="clickable"
        />
      }
      onClose={() => console.log("Modal Closed")}
    >
      <div class={`${commoncss.pdlr15} ${bookclosuretaskscss.taskContainer}`}>
        <div
          class={`${commoncss.pdlr15}  ${commoncss.m_tb_20} ${bookclosuretaskscss.taskContainerLeft}`}
        >
          <img
            src={ChooseFromLib}
            alt="Choose from library"
            style={{ width: "300px" }}
            onClick={() => {
              redirectTo("/myfinv2/book-closure/modules-library");
            }}
          />
        </div>
        <div
          class={`${commoncss.pdlr15} ${commoncss.m_tb_20} ${bookclosuretaskscss.taskContainerRight}`}
        >
          <img
            src={AddNewTask}
            alt="Choose from library"
            style={{ width: "300px" }}
            onClick={() => {
              setAddNewTaskModal(true);
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default AddTaskModal;
